module.exports = __webpack_public_path__ + "img/manager.d73167aa.svg";